import { useTranslation } from "react-i18next";

import { apiAxios, pureApiAxios } from "api/apiAxios";

const api = [apiAxios, pureApiAxios];

export const useLanguageHeader = () => {
  const { i18n } = useTranslation();

  api.forEach((api) => {
    api.interceptors.request.use((config) => {
      if (!config.headers) config.headers = {};
      config.headers["Accept-Language"] = i18n.language;

      return config;
    });
  });
};
